import { render, staticRenderFns } from "./driver_detail_tbn.vue?vue&type=template&id=c501d1b8&"
import script from "./driver_detail_tbn.vue?vue&type=script&lang=js&"
export * from "./driver_detail_tbn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports